import { resolveApiErrorMessage } from '@formosa/shared/i18n/resolveApiErrorMessage';
import { formatMoneyDisplay } from '../finance/financeMoney';

const PRESENTATION_STATUSES = Object.freeze([
  'AWAITING_PAYMENT',
  'PAID_PENDING_RELEASE',
  'RELEASED',
  'REFUNDED',
  'CANCELLED',
]);

export function hostCommercePresentationStatuses() {
  return PRESENTATION_STATUSES;
}

export function moneyWithCurrency(amount, currencyCode) {
  const display = formatMoneyDisplay(amount ?? '0');
  const currency = typeof currencyCode === 'string' && currencyCode.trim() ? currencyCode.trim() : '';
  return currency ? `${display} ${currency}` : display;
}

export function hostCommerceErrorMessage(cause, t) {
  if (typeof t !== 'function') {
    return resolveApiErrorMessage(cause, (key) => key, 'travel.commerce.history.loadFailed');
  }
  return resolveApiErrorMessage(cause, t, 'travel.commerce.history.loadFailed');
}

export function presentationStatusLabel(status, t) {
  if (!status) return '';
  return t(`travel.commerce.history.status.${status}`);
}
